import { Component, OnInit } from '@angular/core';

import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { DataService, HTTPService, HelperService } from 'app/services';
import { DateService } from 'app/services/date.service';
import { datetimeFormat } from 'app/constants/date-time-format';
import * as moment from 'moment';

@Component({
  selector: 'app-add-technician-attendence-dialogue',
  templateUrl: './add-technician-attendence-dialogue.component.html',
  styleUrls: ['./add-technician-attendence-dialogue.component.scss'],
})
export class AddTechnicianAttendenceDialogueComponent implements OnInit {
  data: any = {};
  errors: any = {};
  techAttendence: any = {
    isClockIn: false,
    startDate: '',
    endDate: '',
    startTime: '',
    endTime: '',
    code: '',
    orderId: '',
    title: '',
    workId: '',
    action: '',
    actionLabel: '',
  };
  currentDateTime: any;
  isValidEndTime: boolean = false;
  isValidStartTime: boolean = false;

  isValidAttendStartTime: boolean = false;
  isValidAttendEndTime: boolean = false;

  endTimeOverLap: boolean = false;
  startTimeOverLap: boolean = false;

  clockInDetected: boolean = false;
  clockOutDetected: boolean = false;

  isClockIn: boolean = false;
  techClockIn: boolean = false;
  isToday: boolean = false;

  techId: string = '';
  startDate: string = '';
  endDate: string = '';

  serviceStartTime: any;
  serviceEndTime: any;
  attendenceStartTime: any;
  attendenceEndTime: any;

  IsValid: boolean = false;
  techSerivces: any = [];
  techRO: any = [];
  dupTechRO: any = [];
  services: any = [];
  dupServices: any = [];
  isLoading: boolean = false;
  techName: string = '';
  attendence = {
    type: {
      label: 'Internal',
      name: 'Internal',
      value: 'internal',
      icon: 'far fa-user',
      placeholder: 'Internal',
    },
  };
  attendenceTypes: any[] = [
    {
      label: 'Attendence timelog',
      name: 'Attendence timelog',
      value: 'clock',
      isClockIn: true,
      icon: 'far fa-user',
      placeholder: 'Attendence timelog',
    },
    {
      label: 'Service timelog',
      name: 'Service timelog',
      value: 'service',
      isClockIn: false,
      icon: 'far fa-cars',
      placeholder: 'Service timelog',
    },
  ];
  statusTypes: any[] = [
    {
      label: 'Completed',
      value: 'completed',
    },
    {
      label: 'Paused',
      value: 'pause',
    },
  ];
  isCreateLoading: boolean = false;

  constructor(
    public dConfig: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private httpService: HTTPService,
    private helperService: HelperService,
    public dataService: DataService,
    private dateService: DateService
  ) {}

  ngOnInit() {
    this.data = this.dConfig.data;
    this.techId = this.data.id;
    this.startDate = this.data.startDate;
    this.endDate = this.data.endDate;
    this.techName = this.data.techName;
    this.isClockIn = this.data.isClockIn;
    this.attendence.type = this.attendenceTypes[0];
    this.techAttendence.isClockIn = this.attendenceTypes[0].isClockIn;
    this.getTechServicesById(this.techId);
    this.getTechDetails();
  }

  async getTechDetails() {
    this.currentDateTime = await this.httpService.getServerTime();
    this.currentDateTime = this.dateService.getCurrentDateTimeTz(this.currentDateTime);

    this.isToday = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date().getTime()), datetimeFormat.yyymmdd) === this.startDate ? true : false;
  }

  getTechServicesById(id: string) {
    this.isLoading = true;
    this.httpService.getTechServicesById(id).then(
      (service: any) => {
        this.techSerivces = service;
        if (service) {
          service.forEach((element) => {
            this.techRO.push({ code: element.code, _id: element._id });
            this.dupTechRO.push({ code: element.code, _id: element._id });
          });
        }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  getTimeOverlap(action, startTime, endTime) {
    let query = {
      startDate: this.startDate,
      endDate: this.endDate,
      startTime: startTime ? this.dateService.formatDate(startTime, datetimeFormat.hhmm) : '',
      endTime: endTime ? this.dateService.formatDate(endTime, datetimeFormat.hhmm) : '',
      action: action,
    };
    this.httpService.detectTimeOverlap(this.techId, query).then(
      (res: any) => {
        if (res) {
          this.startTimeOverLap = res.startTimeOverLap;
          this.endTimeOverLap = res.endTimeOverLap;
          this.clockInDetected = false;
          if (action) {
            if (res.clockInDetected || res.clockOutDetected) {
              this.clockInDetected = res.clockInDetected;
            } else if (res.startTimeOverLap) {
              this.startTimeOverLap = res.startTimeOverLap;
            } else if (res.endTimeOverLap) {
              this.endTimeOverLap = res.endTimeOverLap;
            }
          }
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  formatAMPM(date) {
    if (date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      hours = hours < 10 ? '0' + hours : hours;
      minutes = minutes < 10 ? '0' + minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    }
  }

  handleChange(type: string, event: any) {
    this.techAttendence.isClockIn = event.isClockIn;
    this.attendence.type = event;
    this.startTimeOverLap = false;
    this.endTimeOverLap = false;
  }

  async handleAttendenceTime(type: string) {
    this.currentDateTime = await this.httpService.getServerTime();
    this.currentDateTime = this.dateService.getCurrentDateTimeTz(this.currentDateTime);

    if (this.dateService.formatDate(this.currentDateTime.getTime(), datetimeFormat.yyymmdd) === this.startDate) {
      if (this.attendenceStartTime) {
        const startDate = new Date(
          this.currentDateTime.getFullYear(),
          this.currentDateTime.getMonth(),
          this.currentDateTime.getDate(),
          this.attendenceStartTime.getHours(),
          this.attendenceStartTime.getMinutes()
        );
        if (startDate > this.currentDateTime) {
          this.isValidAttendStartTime = true;
          return;
        }
      }
      if (this.attendenceEndTime) {
        const endDate = new Date(
          this.currentDateTime.getFullYear(),
          this.currentDateTime.getMonth(),
          this.currentDateTime.getDate(),
          this.attendenceEndTime.getHours(),
          this.attendenceEndTime.getMinutes()
        );
        if (endDate > this.currentDateTime) {
          this.isValidAttendEndTime = true;
          return;
        }
      }
    }

    if (type === 'attendenceStartTime') {
      this.errors.attendenceStartTime = '';

      let from = new Date(Date.parse(this.attendenceStartTime));
      let to = new Date(Date.parse(this.attendenceEndTime));
      this.isValidAttendStartTime = from > to ? true : false;
      this.isValidAttendEndTime = from > to ? true : false;
    } else if (type === 'attendenceEndTime') {
      this.errors.attendenceEndTime = '';

      let from = new Date(Date.parse(this.attendenceStartTime));
      let to = new Date(Date.parse(this.attendenceEndTime));
      this.isValidAttendStartTime = from > to ? true : false;
      this.isValidAttendEndTime = from > to ? true : false;
    }

    if (this.attendenceStartTime && this.attendenceEndTime) {
      if (!this.isValidAttendStartTime && !this.isValidAttendEndTime) {
        this.getTimeOverlap('clock', this.attendenceStartTime, this.attendenceEndTime);
      }
    }
  }

  async handleServiceTime(type: string) {
    this.currentDateTime = await this.httpService.getServerTime();
    this.currentDateTime = this.dateService.getCurrentDateTimeTz(this.currentDateTime);

    if (type === 'serviceStartTime') {
      if (this.dateService.formatDate(this.currentDateTime.getTime(), datetimeFormat.yyymmdd) === this.startDate) {
        const startDate = new Date(
          this.currentDateTime.getFullYear(),
          this.currentDateTime.getMonth(),
          this.currentDateTime.getDate(),
          this.serviceStartTime.getHours(),
          this.serviceStartTime.getMinutes()
        );
        if (startDate > this.currentDateTime) {
          this.isValidStartTime = true;
          return;
        }
      }
      this.errors.serviceStartTime = '';

      let from = new Date(Date.parse(this.serviceStartTime));
      let to = new Date(Date.parse(this.serviceEndTime));
      this.isValidStartTime = from > to ? true : false;
      this.isValidEndTime = from > to ? true : false;
    } else if (type === 'serviceEndTime') {
      if (this.dateService.formatDate(this.currentDateTime.getTime(), datetimeFormat.yyymmdd) === this.startDate) {
        const endDate = new Date(this.currentDateTime.getFullYear(), this.currentDateTime.getMonth(), this.currentDateTime.getDate(), this.serviceEndTime.getHours(), this.serviceEndTime.getMinutes());
        if (endDate > this.currentDateTime) {
          this.isValidEndTime = true;
          return;
        }
      }
      this.errors.serviceEndTime = '';

      let from = new Date(Date.parse(this.serviceStartTime));
      let to = new Date(Date.parse(this.serviceEndTime));
      this.isValidStartTime = from > to ? true : false;
      this.isValidEndTime = from > to ? true : false;
    }

    if (this.serviceStartTime && this.serviceEndTime) {
      if (!this.isValidStartTime && !this.isValidEndTime) {
        this.getTimeOverlap('service', this.serviceStartTime, this.serviceEndTime);
      }
    }
  }

  /** Getting data from dropdown */
  handleSelect(type: string, value: any) {
    if (type === 'code') {
      this.techAttendence[type] = value.code;
      this.techAttendence.orderId = value._id;
      this.techAttendence.title = '';
      this.techAttendence.workId = '';
      this.errors.orderId = '';
      this.dupServices = [];
      this.services = [];

      this.techSerivces.filter((service) => {
        if (this.techAttendence.orderId === service._id) {
          this.services = service.services;
          this.dupServices = service.services;
        }
      });
    } else if (type === 'title') {
      this.techAttendence[type] = value.title;
      this.techAttendence.workId = value.serviceId;
      this.errors.workId = '';
    } else if (type === 'action') {
      this.techAttendence[type] = value.value;
      this.techAttendence.actionLabel = value.label;
      this.errors.action = '';
    }
  }

  /** Blur input fields */
  blurInput(type?: string) {}

  /** Focus on input fields */
  focusInput(type: string) {}

  onSearchItem(type: string, value) {
    if (type === 'code') {
      const query = value.toLowerCase();
      this.dupTechRO = this.techRO.filter(({ code }) => code.toLowerCase().includes(query));
    } else if (type === 'title') {
      const query = value.toLowerCase();
      this.dupServices = this.services.filter(({ title }) => title.toLowerCase().includes(query));
    }
  }

  handleClear(type: string, value) {
    if (type === 'code') {
      this.dupTechRO = this.techRO;
    } else if (type === 'title') {
      this.dupServices = this.services;
    }
  }

  validateSeriveTime() {
    this.IsValid = true;
    this.errors = {};

    if (!this.techAttendence.orderId) {
      this.errors.orderId = '*RO# required';
      this.IsValid = false;
    }

    if (!this.techAttendence.title) {
      this.errors.workId = '*Service required';
      this.IsValid = false;
    }

    if (!this.techAttendence.action) {
      this.errors.action = '*Status required';
      this.IsValid = false;
    }

    if (!this.serviceStartTime) {
      this.errors.serviceStartTime = '*Start time required';
      this.IsValid = false;
    }

    if (!this.serviceEndTime) {
      this.errors.serviceEndTime = '*End time required';
      this.IsValid = false;
    }

    if (this.isValidStartTime || this.isValidEndTime) {
      this.IsValid = false;
    }

    if (this.startTimeOverLap) {
      this.IsValid = false;
      this.helperService.showToaster('error', 'Start time overlap.');
    }

    if (this.endTimeOverLap) {
      this.IsValid = false;
      this.helperService.showToaster('error', 'End time overlap.');
    }

    if (this.clockInDetected) {
      this.IsValid = false;
      this.helperService.showToaster('error', 'The service start and end times do not match with the attendance logs.');
    }

    return this.IsValid;
  }

  validateAttendenceTime() {
    this.IsValid = true;
    this.errors = {};

    if (!this.attendenceStartTime) {
      this.errors.attendenceStartTime = '*Start time required';
      this.IsValid = false;
    }

    if (!this.attendenceEndTime) {
      this.errors.attendenceEndTime = '*End time required';
      this.IsValid = false;
    }

    if (this.clockInDetected) {
      this.IsValid = false;
      this.helperService.showToaster('error', 'Start and end times overlap with the attendance logs.');
    }

    if (this.isValidAttendStartTime || this.isValidAttendEndTime) {
      this.IsValid = false;
    }

    if (this.startTimeOverLap || this.endTimeOverLap) {
      this.IsValid = false;
    }

    return this.IsValid;
  }

  handleSubmit() {
    if (this.isCreateLoading) {
      return;
    }

    if (!this.techAttendence.isClockIn) {
      let serviceTimelog = {
        isClockIn: false,
        startDate: this.startDate,
        endDate: this.endDate,
        startTime: this.dateService.formatDate(this.serviceStartTime, datetimeFormat.hhmm),
        endTime: this.dateService.formatDate(this.serviceEndTime, datetimeFormat.hhmm),
        orderId: this.techAttendence.orderId,
        workId: this.techAttendence.workId,
        action: this.techAttendence.action,
        title: this.techAttendence.title,
        techName: this.techName,
      };

      if (this.validateSeriveTime()) {
        this.createTechService(serviceTimelog);
      }
    } else if (this.techAttendence.isClockIn) {
      let attendenceTimelog = {
        isClockIn: true,
        startDate: this.startDate,
        endDate: this.endDate,
        startTime: this.dateService.formatDate(this.attendenceStartTime, datetimeFormat.hhmm),
        endTime: this.dateService.formatDate(this.attendenceEndTime, datetimeFormat.hhmm),
        techId: this.techId,
        techName: this.techName,
      };
      if (this.validateAttendenceTime()) {
        this.createTechService(attendenceTimelog);
      }
    }
  }

  createTechService(data) {
    if (this.startTimeOverLap || this.endTimeOverLap) {
      return;
    }
    this.isLoading = true;
    this.isCreateLoading = true;
    this.httpService
      .createTechService(this.techId, data)
      .then(
        (data: any) => {
          this.dataService.sendData(this.dataService.typePassData('company-appdata-updated', {}));
          this.isLoading = false;

          this.helperService.showToaster('success', 'Successfully created');
          this.closeAttendenceModal({});
        },
        (err) => {
          this.isLoading = false;
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isCreateLoading = false;
      });
  }

  closeAttendenceModal(data: any) {
    this.ref.close(data);
  }
}
